<template>
  <div v-if="isLoading">
    <LoaderIcon></LoaderIcon>
  </div>
  <div v-else>
    <div
      class="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 z-20"
    >
      <div class="w-full space-y-8">
        <h2 class="textHeadline2 text-center mb-8">{{ title }}</h2>
        <div
          class="max-w-7xl mx-auto flex justify-center py-12 px-4 sm:px-6 lg:px-8 z-20 flex-col"
          v-html="content"
        ></div>
      </div>
    </div>
    <FooterLinks />
  </div>
</template>

<script>
import LoaderIcon from "../../../components/v2/loader/LoaderIcon.vue";
import FooterLinks from "../../../components/v2/sbk/FooterLinks.vue";
import { fetchSites } from "~/api/sbk";

export default {
  name: "SbkSitePage",
  components: {
    FooterLinks,
    LoaderIcon,
  },
  data() {
    return {
      isLoading: Boolean,
      title: null,
      content: null,
    };
  },
  async mounted() {
    this.reloadSites();
  },
  updated() {
    this.reloadSites();
  },
  methods: {
    reloadSites() {
      fetchSites()
        .then((sites) => {
          if (sites.data && sites.data[this.$route.params.name]) {
            this.isLoading = false;
            this.title = sites.data[this.$route.params.name].title;
            this.content = sites.data[this.$route.params.name].content;
          } else {
            return this.$router.push({
              name: "maintenancePage",
            });
          }
        })
        .catch(() => {
          // redirect to maintenance page if request fails
          return this.$router.push({
            name: "maintenancePage",
          });
        });
    },
  },
};
</script>
